import React, { useEffect, useState  } from 'react';
import L from 'leaflet';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';
import { useMap } from 'react-leaflet';
import './CustomDrawControl.css';  // Import your custom CSS
import proj4 from 'proj4';
// Change the button title + screen reader text
L.drawLocal.edit.toolbar.buttons.edit = "Modify vertices";
L.drawLocal.edit.toolbar.buttons.remove = "Delete shapes";

const CustomDrawControl = ({  onBoundingBoxChange, layer1, valueReset1, overlay }) => {
  const map = useMap();
  proj4.defs([
    ["EPSG:3413","+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs"]
]);
    const [previousOverlay, setpreviousOverlay] = useState(null);
const [previousLayer, setpreviousLayer] = useState('ok');
const [valueReset, setValueReset] = useState(null)

    


  useEffect(() => {
    
    const featureGroup = new L.FeatureGroup().addTo(map);
    let unionLayer = null; 
    let list_bounds = [];
    // Create a custom draw control
    const CustomDrawControl = L.Control.extend({
      onAdd: function () {
        const container = L.DomUtil.create('div', 'custom-draw-control border border-gray-400 border-[2px] !py-[15px]');
        
        // Create and add the title for the first control
        const title = L.DomUtil.create('div', 'custom-draw-title text-gray-700', container);
        title.innerText = 'Search by…';
        
        // Create and add the first draw control
        const drawControl1 = new L.Control.Draw({
          draw: {
            rectangle: true,
            polyline: false,
            circle: false,
            marker: false,
            polygon: true,
            circlemarker: false,
          },
        }).addTo(map);

        // Create a separate container for the first draw control
        const drawControl1Container = L.DomUtil.create('div', 'draw-control-container');
        drawControl1Container.appendChild(drawControl1.getContainer());
        container.appendChild(drawControl1Container);

        // Create and add the title for the second control
        const title1 = L.DomUtil.create('div', 'custom-draw-title1 text-gray-700 pt-[25px]', container);
        title1.innerText = 'Edit shapes';

        // Create and add the second draw control
        const drawControl2 = new L.Control.Draw({
          draw: {
            rectangle: false,
            polyline: false,
            circle: false,
            marker: false,
            polygon: false,
            circlemarker: false,
          },
          edit: {
            featureGroup: featureGroup,
          },
        }).addTo(map);

        // Create a separate container for the second draw control
        const drawControl2Container = L.DomUtil.create('div', 'draw-control-container');
        drawControl2Container.appendChild(drawControl2.getContainer());
        container.appendChild(drawControl2Container);

        return container;
      },
    });

    // Add the custom control to the map
    const customDrawControl = new CustomDrawControl({
      position: 'topleft' // Adjust position as needed
    }).addTo(map);
    
      let unionBounds = null; 
       let bbox = {};
      let bbox1 = {};
     
    // Handle created shapes
    map.on('draw:created', (e) => {
      const { layer } = e;
      featureGroup.addLayer(layer);
     
   
      
      if (layer instanceof L.Rectangle) {
        const bounds = layer.getBounds();
          
        bbox = {
          xmin: bounds.getWest(),
          xmax: bounds.getEast(),
          ymin: bounds.getSouth(),
          ymax: bounds.getNorth(),
        };
       
        
        const x_min  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmin, bbox.ymin]);
        const y_min  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmin, bbox.ymax]);
        const x_max  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmax, bbox.ymin]);
        const y_max  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmax, bbox.ymax]);
        bbox1 = {
          xmin: x_min[0],
          xmax: x_max[0],
          ymin: x_min[1],
          ymax: y_max[1],}
      } else if (layer instanceof L.Polygon) {
        const latlngs = layer.getLatLngs()[0];
        const lats = latlngs.map(latlng => latlng.lat);
        const lngs = latlngs.map(latlng => latlng.lng);
        bbox = {
          xmin: Math.min(...lngs),
          xmax: Math.max(...lngs),
          ymin: Math.min(...lats),
          ymax: Math.max(...lats),
        };
        const x_min  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmin, bbox.ymin]);
        const y_min  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmin, bbox.ymax]);
        const x_max  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmax, bbox.ymin]);
        const y_max  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmax, bbox.ymax]);
        bbox1 = {
          xmin: x_min[0],
          xmax: x_max[0],
          ymin: x_min[1],
          ymax: y_max[1],}
      
      }
         list_bounds.push(bbox)
     if (unionLayer) {
        map.removeLayer(unionLayer);
      }

     

        // Pass the bounding box coordinates to the parent component
        let uniqueList = [...new Set(list_bounds)];
        
        onBoundingBoxChange(uniqueList);
      
    });
      
    // Handle edited shapes
    map.on('draw:edited', (e) => {
        
         list_bounds = [];
        const layers = e.layers;
         featureGroup.eachLayer((layer) => {
          let bbox = {};
          let bbox1 = {};

      if (layer instanceof L.Rectangle) {
        const bounds = layer.getBounds();
        bbox = {
          xmin: bounds.getWest(),
          xmax: bounds.getEast(),
          ymin: bounds.getSouth(),
          ymax: bounds.getNorth(),
        };
       
        const x_min  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmin, bbox.ymin]);
        const y_min  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmin, bbox.ymax]);
        const x_max  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmax, bbox.ymin]);
        const y_max  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmax, bbox.ymax]);
        bbox1 = {
          xmin: x_min[0],
          xmax: x_max[0],
          ymin: x_min[1],
          ymax: y_max[1],}
          console.log(bbox,'bbox')
      
      
      } else if (layer instanceof L.Polygon) {
        const latlngs = layer.getLatLngs()[0];
        const lats = latlngs.map(latlng => latlng.lat);
        const lngs = latlngs.map(latlng => latlng.lng);
        bbox = {
          xmin: Math.min(...lngs),
          xmax: Math.max(...lngs),
          ymin: Math.min(...lats),
          ymax: Math.max(...lats),
        };  

        const x_min  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmin, bbox.ymin]);
        const y_min  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmin, bbox.ymax]);
        const x_max  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmax, bbox.ymin]);
        const y_max  = proj4('EPSG:4326', 'EPSG:3413', [bbox.xmax, bbox.ymax]);
        bbox1 = {
          xmin: x_min[0],
          xmax: x_max[0],
          ymin: x_min[1],
          ymax: y_max[1],}

      }
            // Pass the updated bounding box coordinates to the parent component
             list_bounds.push(bbox)
          
        });
        onBoundingBoxChange(list_bounds);
      });

      // Handle edited shapes
    map.on('draw:deleted', (e) => {
        list_bounds = [];
      const layers = e.layers;
      layers.eachLayer((layer) => {
        let bbox = {};

      if (layer instanceof L.Rectangle) {
        const bounds = layer.getBounds();
        bbox = {
          xmin: '',
          xmax: '',
          ymin: '',
          ymax: '',
        };
      } else if (layer instanceof L.Polygon) {
        const latlngs = layer.getLatLngs()[0];
        const lats = latlngs.map(latlng => latlng.lat);
        const lngs = latlngs.map(latlng => latlng.lng);
        bbox = {
          xmin: '',
          xmax: '',
          ymin: '',
          ymax: '',
        };  }
          list_bounds.push(bbox)
          // Pass the updated bounding box coordinates to the parent component
          onBoundingBoxChange(null);
          if (unionLayer) {
        map.removeLayer(unionLayer);
      }
         unionBounds = null
         
        
      });
    });

if (overlay !== previousOverlay ) {
   
  map.eachLayer((layer) => {
    if (layer instanceof L.Rectangle) {
      // Check if the layer matches the current overlay (same layer check)
      
        map.removeLayer(layer);
        onBoundingBoxChange(null);
     
    }
  });

  // Update previousOverlay after removal
  setpreviousOverlay(overlay);
}




      
    return () => {
      map.off('draw:created');
      map.off('draw:edited');
      map.off('draw:deleted');
        if (unionLayer) {
        map.removeLayer(unionLayer);
      }

      map.removeControl(customDrawControl);
    };
  }, [map,overlay, previousOverlay, valueReset]);

    

useEffect(() => {
         let counter = 0;  
const control = L.control({ position: 'topleft' });

control.onAdd = () => {
  const div = L.DomUtil.create('div', 'custom-draw-reset border border-gray-400 border-[2px] px-[5px] text-black text-[24px] custom-reset');
  
  div.innerHTML = `
  <button class="button-reset" title="Reset view">
  <i class="fas fa-redo"></i>
</button>
  `;

 
const reset = div.querySelector('.button-reset');
 reset.addEventListener('click', (event) => {
   valueReset1(layer1)
  });
  return div;
};

const control2 = L.control({ position: 'topleft' });

control2.onAdd = () => {
  const div = L.DomUtil.create('div', 'custom-draw-reset border border-gray-400 border-[2px] px-[5px] text-black text-[24px] custom-reset2');
  
  div.innerHTML = `
  <a href="http://taipidata.ncu.edu.tw/docs" target="_blank" rel="noopener noreferrer">
  <button class="button-reset ">
    Docs
</button>
  `;

 
  return div;
};
control.addTo(map);
control2.addTo(map);
     },[map,layer1])

  return null;
};

export default CustomDrawControl;
